export const isEnumEqual = <T extends number | string>(
  value: unknown,
  enumMember: T
): value is T => value === enumMember;

export const isOneOfEnums = <T extends number | string>(
  value: unknown,
  enumMembers: readonly T[]
): value is T =>
  enumMembers.some((enumMember) => isEnumEqual<T>(value, enumMember));
